import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { CheckboxDialogOptions } from "./checkbox-dialog";
import { CheckboxDialogComponent } from "./checkbox-dialog.component";


@Injectable()
export class CheckboxDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Checkbox Dialog Service Call
    
    Open(options?: CheckboxDialogOptions): Observable<boolean> {
        const dlgoptions: MatDialogConfig<any> = {
            disableClose: true,
            data: {
                TitleText: 'Information Requested',
                MessageText: '',
                ...options,
            },
            panelClass: 'checkboxdialog',
            maxWidth: '450px',
            maxHeight: '85vh',
        };

        const openHandle = this.matDialog.open<CheckboxDialogComponent>(CheckboxDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion
}